import { isOutreach } from "@shared/auth/guards";
import { isInvestorOnlyRole, isOutreachOnlyRole } from "@shared/auth/roles";
import type { GlobalRole } from "@shared/auth/roles";

export const OUTREACH_HOME = "/admin/prospects";

export const ADMIN_HOME = "/admin";
export const INVESTOR_HOME = "/investor";
export const PUBLIC_HOME = "/";
export const SETUP_HOME = "/setup";
export const CUSTOMER_HOME = "/dashboard";

export function homePathForRole(role: GlobalRole | undefined): string {
  if (isOutreachOnlyRole(role)) return OUTREACH_HOME;
  if (isInvestorOnlyRole(role)) return INVESTOR_HOME;
  if (isOutreach(role)) return ADMIN_HOME;
  return PUBLIC_HOME;
}

export function viewAsHomeForRole(role: GlobalRole | undefined): string {
  const home = homePathForRole(role);
  return home === PUBLIC_HOME ? CUSTOMER_HOME : home;
}

export function homePathWithoutCompany(
  role: GlobalRole | undefined,
  returnTo?: string,
): string {
  const home = homePathForRole(role);
  if (home !== PUBLIC_HOME) return home;
  return returnTo
    ? `${SETUP_HOME}?${new URLSearchParams({ returnTo }).toString()}`
    : SETUP_HOME;
}
